'use client';

import { c as _c } from "react/compiler-runtime";
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';
import { getBranchConfig } from './utils';
export const BranchV2 = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getBranchConfig();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const config = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      src: config.branchScriptUrl,
      consentGroup: "C0004",
      onReady: () => {
        if (!window.branch?.init || !config.branchKey) {
          return;
        }
        window.branch.init(config.branchKey, {
          ...(config.enableJourneys && {
            enable_journeys: true
          }),
          ...(config.debug && {
            debug: true
          })
        });
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useConsentGatedInit(t1);
  return null;
};